import { BreakpointObserver, Breakpoints, BreakpointState } from '@angular/cdk/layout';
import { Location } from '@angular/common';
import { Component, EventEmitter, HostListener, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { ApiService } from '../../services'; 
Location

@Component({
  selector: 'app-side-panel',
  templateUrl: './side-panel.component.html',
  styleUrls: ['./side-panel.component.less']
})
export class SidePanelComponent implements OnInit {
  deviceHeight:number;
  allOrder:boolean;
  searchOrder:boolean;
  newOrder:boolean;
  designBookings:boolean;
  designContactLog:boolean;
  browserCat:boolean;
  newProduct:boolean;
  cbInventory:boolean;
  mailing:boolean;
  newProducts:boolean;
  editProducts:boolean;
  merchandising:boolean;
  productIntake:boolean;
  pickup:boolean;  bpObserver: Observable<BreakpointState> = this.breakpointObserver.observe(
    Breakpoints.Handset
  );
  bpSubscription: Subscription;
  isHandset = false;
  headerName: string;
  showSideNav = false;
  userType: any;
  @Output() panelStatusChange = new EventEmitter();
  fav: boolean;
  partners: boolean;


  constructor(private location:Location,private router:Router,public api:ApiService,
    private breakpointObserver: BreakpointObserver) { 
    this.deviceHeight = window.innerHeight;
    this.bpSubscription = this.bpObserver.subscribe(
      (handset: BreakpointState) => {
        this.isHandset = handset.matches;
        if (!this.isHandset) {
          //this.selectedOrder = "";
        }
      }
    );
  }
    @HostListener('window:resize', ['$event'])
      resize(event){
        this.deviceHeight = window.innerHeight;
      }
   
  ngOnInit(): void { 
    if(JSON.parse(localStorage.getItem('user'))){
      this.userType = JSON.parse(localStorage.getItem('user')).authorization;
    }
    if(this.location.path() === '/admin/dashboard/orders/active'){
      this.allOrder = true;
      this.headerName = 'All Orders';
    } else  if(this.location.path() === '/admin/dashboard/orders/search'){
      this.searchOrder = true;
      this.headerName = 'Search Orders';

    } else  if(this.location.path() === '/admin/dashboard/orders/pickups'){
      this.pickup = true;
      this.headerName = 'Order Pickups';

    } else  if(this.location.path().includes('/admin/dashboard/orders/new-order')){
      this.newOrder = true;
      this.headerName = 'New Order';
    } else  if(this.location.path() === '/admin/dashboard/design/rooms'||
    this.location.path().includes('/design/projects/') ){
      this.headerName = this.location.path() === '/admin/dashboard/design/rooms' ? 'Design Bookings' : '';
      this.designBookings = true;
    }  else  if(this.location.path().includes('/design-contact-log')){
      this.designContactLog = true;
      this.headerName = 'Design Contact Log';
    } else  if(this.location.path().includes('/design/designer/products/all')){
      this.browserCat = true;
      this.headerName = 'Browse Catalogue';
    } else  if(this.location.path().includes('/design/designer/products/favorites')){
      this.fav = true;
      this.headerName = 'My Saved Items';
    }else  if(this.location.path() === '/admin/dashboard/add-product'){
      this.headerName = 'New Product';
      this.newProduct = true;
    } else  if(this.location.path() === '/admin/dashboard/cb-inventory'){
      this.cbInventory = true;
      this.headerName = 'CB / CB2 Inventory Lookup';
    }  
    else  if(this.location.path() === '/admin/dashboard/mailing-list'){
      this.mailing = true;
      this.headerName = 'Mailing List';
    }    else  if(this.location.path() === '/admin/dashboard/partners'){
      this.partners = true;
      this.headerName = 'Partners List';
    }   else  if(this.location.path().includes('admin/dashboard/edit-products')){
      this.editProducts = true;
      this.headerName = 'Edit Product Dashboard';
    }   else  if(this.location.path().includes('admin/dashboard/new-products')){
      this.newProducts = true;
      this.headerName = 'New Product Dashboard';
    }  else  if(this.location.path().includes('admin/dashboard/merchandising/product-intake')){
      this.productIntake = true;
      this.headerName = 'Product Intake';
    }
    else  if(this.location.path().includes('admin/dashboard/merchandising/edit')){
      this.merchandising = true;
      this.headerName = 'Merchandising Dashboard';
    } 
    else {
      this.allOrder = false;
      this.searchOrder = false;
      this.newOrder = false;
      this.designBookings = false;
      this.designContactLog = false;
      this.browserCat =false;
      this.newProduct = false;
      this.cbInventory  = false;
      this.fav = false;
      this.partners = false;
      this.editProducts = false;
      this.newProducts = false;
      this.productIntake = false;
      this.merchandising = false;
      this.headerName = '';
  }
}

  navigation(path:string){
    if (path.includes('?')) {
    const [route, queryString] = path.split('?');
const queryParams = Array.from((new URLSearchParams(queryString) as any).entries())
  .reduce((acc, [key, value]) => {
    acc[key] = value;
    return acc;
  }, {} as any);


    this.router.navigate([route], { queryParams });
  } else {
    this.router.navigate([path]);
  }
  }

  reset(){
    this.allOrder = false;
    this.searchOrder = false;
    this.newOrder = false;
    this.designBookings = false;
    this.designContactLog = false;
    this.browserCat =false;
    this.newProduct = false;
    this.cbInventory  = false;
    this.fav = false;
      this.partners = false;
      this.editProducts = false;
      this.newProducts = false;
      this.productIntake = false;
      this.merchandising = false;
  }

  toggleSideNav(){
    this.api.isAdminSidePanelOpened = !this.api.isAdminSidePanelOpened;
    this.panelStatusChange.emit(this.api.isAdminSidePanelOpened);
  }

}
